<template>
    <a :href="item.url" :class="item.class" class="flex items-center h-10 px-4" v-html="item.name"></a>
</template>

<script>
export default {
    props: ['item']
};
</script>